import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Button, IconButton } from '@mui/material';
import { ReactNode } from 'react';
import { toast } from 'react-toastify';

interface CopyToClipboardProps {
  label?: ReactNode;
  content: string;
  disabled?: boolean;
  ariaLabel?: string;
  // Renders a small, icon-only button instead of the default text Button —
  // for inline use next to a value where a full button would be too heavy.
  compact?: boolean;
}
const CopyToClipboard = ({
  label = '',
  content,
  disabled = false,
  ariaLabel = label ? undefined : 'Copy to clipboard',
  compact = false,
}: CopyToClipboardProps) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(content).then(
      () => {
        // Text successfully copied to clipboard
        toast.success('Copied to clipboard!');
      },
      (err) => {
        // Unable to copy to clipboard
        // eslint-disable-next-line no-console
        console.error('Could not copy text: ', err);
        toast.error('Could not copy text to clipboard', {
          autoClose: false,
          hideProgressBar: true,
        });
      },
    );
  };

  if (compact) {
    // FileCopy is a solid, heavier-looking glyph than the thin-outline
    // ContentCopy — Material Icons has no font-weight axis to go "bold" with,
    // so a visually bolder icon is the closest real equivalent.
    return (
      <IconButton
        size="small"
        color="primary"
        onClick={handleCopy}
        disabled={disabled}
        aria-label={ariaLabel}
        sx={{ p: '3px' }}
      >
        <FileCopyIcon sx={{ fontSize: 16 }} />
      </IconButton>
    );
  }

  return (
    <Button variant="text" onClick={handleCopy} disabled={disabled} aria-label={ariaLabel}>
      {label}
      <ContentCopyIcon fontSize="small" />
    </Button>
  );
};

export default CopyToClipboard;
